import { List } from 'immutable';
import I18n from 'I18n';
import { sortOptionsByText } from 'reporting-snowflake/shared/lib/utils';
import { getDefaultExpressions } from 'reporting-snowflake/relational/utils/default-expression-utils';
import { getDefaultPropertyData } from 'reporting-snowflake/relational/utils/magic-measure-utils';
import { filterListOfPropertiesByInitialProperties } from '../../lib/relational-report-utils/property-utils';
import useFetchUserInfo from '../useFetchUserInfo';
const createDefaultPropertiesDropdownData = (expressions, propertyData) => {
  if (expressions.length === 0 && propertyData.length === 0) {
    return [];
  }
  return [{
    text: I18n.text('report-customization-components.customization-components.relational-report.default-measures'),
    value: I18n.text('report-customization-components.customization-components.relational-report.default-measures'),
    options: [...expressions.map(expression => ({
      text: expression.text,
      value: `.${expression.value.alias}`,
      disabled: false
    })), ...propertyData.map(measure => ({
      text: measure.text,
      value: `${measure.value.field.table}.${measure.value.field.name}`,
      disabled: measure.isDefault,
      help: measure.isDefault ? I18n.text('report-customization-components.customization-components.relational-report.default-measures-help') : undefined
    }))].sort(sortOptionsByText)
  }];
};
const emptyReturn = {
  allDefaultExpressions: [],
  availableDefaultExpressions: [],
  allDefaultProperties: [],
  availableDefaultPropertyData: [],
  allDefaultPropertiesGroup: [],
  availableDefaultPropertiesGroup: []
};
export const useDefaultProperties = ({
  relationalReport,
  allJoinMetadata,
  fullTableAndPropertyMeta,
  allAvailableColumns
}) => {
  const userInfo = useFetchUserInfo();
  const gates = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.gates) || [];
  const table = relationalReport.table;
  if (!fullTableAndPropertyMeta.data) {
    return Object.assign({
      isDefaultPropertiesLoading: true
    }, emptyReturn);
  }
  const {
    loading,
    data: tableAndPropertyMeta,
    data: {
      tables,
      properties
    }
  } = fullTableAndPropertyMeta;
  if (!loading) {
    const defaultExpressionsResult = getDefaultExpressions({
      tableDescription: table,
      tableAndPropertyMeta,
      allJoinMetadata,
      gates,
      reportDefinition: relationalReport
    });
    const allDefaultExpressions = defaultExpressionsResult && defaultExpressionsResult.isDefault ? List() : defaultExpressionsResult.expressions.flatten().toList();
    const availableDefaultExpressions = allDefaultExpressions.size > 0 ? filterListOfPropertiesByInitialProperties(allDefaultExpressions, allAvailableColumns) : [];
    const defaultPropertyDataResult = getDefaultPropertyData({
      tableDescription: table,
      properties,
      tables,
      allJoinMetadata
    });
    const allDefaultPropertyData = defaultPropertyDataResult.shouldUseAutoJoin ? List(defaultPropertyDataResult.magicMeasures.filter(measure => !measure.tableName)) : List();
    const availableDefaultPropertyData = allDefaultPropertyData.size > 0 ? filterListOfPropertiesByInitialProperties(allDefaultPropertyData, allAvailableColumns) : [];
    const allDefaultPropertiesGroup = createDefaultPropertiesDropdownData(allDefaultExpressions.toArray(), allDefaultPropertyData.toArray());
    const availableDefaultPropertiesGroup = createDefaultPropertiesDropdownData(availableDefaultExpressions, availableDefaultPropertyData);
    return {
      isDefaultPropertiesLoading: false,
      allDefaultExpressions: allDefaultExpressions.toArray(),
      availableDefaultExpressions,
      allDefaultPropertyData: allDefaultPropertyData.toArray(),
      availableDefaultPropertyData,
      allDefaultPropertiesGroup,
      availableDefaultPropertiesGroup
    };
  }
  return Object.assign({
    isDefaultPropertiesLoading: true
  }, emptyReturn);
};